export default "__VITE_ASSET__WIWGnz4Y__"